import { api } from "api/api";
import { AxiosError } from "axios";
import Indicador from "model/indicadores/Indicador";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class IndicadorMinhasColetasService implements BaseServiceCadastros<Indicador> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {

            let url = `/indicador/minhasColetas/pesquisar`;
            if (filters) {
                url += getFilters(filters)
            }
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Indicador>((resolve, reject): void => {
        });
    }

    incluir(indicador: Indicador) {
        return new Promise<Indicador>((resolve, reject): void => {
        });
    }

    editar(indicador: Indicador) {
        return new Promise<Indicador>((resolve, reject): void => {
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
        });
    }
}

export default IndicadorMinhasColetasService;